<template>
  <div>


<h2 class="goth">Pronominaladverb</h2>

<div class="grammatikparagrafbredd leftorient">
<p>På svenska kan en preposition stå före ett substantiv, pronomen, bisats,
    eller infinitivsats utan att böjas eller trixas med. Tyskan är litet knepigare.</p>

<h4>Preposition + substantiv</h4>

<div class="ruta">

    <p><i>Jag väntar på <b>brevbäraren</b>.</i></p>
    <p><i>Ich warte auf <b>den Briefträger</b>.</i></p>
    <br>
    <p><i>Jag väntar på <b>brevet</b>.</i></p>
    <p><i>Ich warte auf <b>den Brief</b>.</i></p>

</div>
 <br>

<p> När ett preposition står framför ett substantiv
    (substantivet blir prepositionsobjekt) skiljer sig inte tyskan
    nämnvärt från svenskan. Man måste bara tänka på om objektet
    står i ackusativ eller dativ (ackusativ i exemplen ovan).
</p>


<br><br>


<h4>Preposition + pronomen</h4>

<div class="ruta">

    <p><i>Har han kommit? Nej, jag väntar på <b>honom</b>.</i></p>
    <p><i>Ist er gekommen?. Nein, ich warte auf <b>ihn</b>.</i></p>
    <br>
    <p><i>Har brevet kommit? Nej, jag väntar <b>på det</b>.</i></p>
    <p><i>Ist der Brief gekommen? Nein, ich warte <b>darauf</b>.</i></p>

</div>
 <br>

<div class="quasi-p"> Om en preposition står framför ett pronomen som syftar på en person,
    är principen likadan som i svenskan, men om pronominet åsyftar en sak,
    smälter <div class="inlajn nej-understryk"><b>preposition och pronomen</b></div> ofta samman till <i>ett</i>
    ord - ett <div class="inlajn -nejunderstryk"><i><b>pronominaladverb</b></i></div>.
    Särskilt om prepositionen åsyftar något abstrakt.<br>
    <div class="mindre inlajn">Sista exemplet ovan kan tolkas både som att man väntar på själva brevet,
    och att man väntar på den händelse att brevet skall komma.</div>
</div>


<br><br>

<h4>Preposition + bisats</h4>

<div class="ruta">
    <p><i>Jag väntar <u>på</u> <b> att mormor kommer tillbaka.</b></i></p>
    <p><i>Ich warte <u>darauf</u>, <b>dass Oma zurückkommt.</b></i></p>
</div>
 <br>

<div class="quasi-p">
    På tyskan kan inte en bisats direkt stå som prepositionsobjekt. Felaktigt exempel:<br><br>
    <i><strike>Ich warte <b>auf</b>, dass Oma zurückkommt.</strike></i>
</div><br>

<div class="quasi-p">
     Man måste använda ett <b>pronominaladverb</b> som platshållare,
     som liksom <b>binder ihop huvudsatsen med kommande bisats</b>:<br><br>


<div class="dubbelrad"><i>Ich warte <b>darauf, </b>&nbsp;<u>dass Oma zurückkommt</u>.</i> &nbsp; <br><div>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <BakatpilStor/></div></div>




</div>
<br>
<p>Pronominaladverbet kommer inte alltid sist i huvudsatsen:</p>

<div class="ruta">

    <p><i>Vi måste vänta på <b>att mormor kommer tillbaka</b>.</i></p>
    <p><i>Wir müssen <u>darauf</u> warten,  <b>dass Oma zurückkommt</b>.</i></p>

</div>

<br><br>

<h4>Preposition + infinitiv</h4>

<div class="ruta">


    <p><i>Jag väntar på <b>att kunna åka skidor.</b></i></p>
    <p><i>Ich warte <u>darauf</u>, <b>Ski fahren zu können.</b></i></p>
</div>
 <br>

<div class="quasi-p">
Även när prepositionsobjektet är en infinitivkonstruktion används pronominaladverb
som platshållare på liknande sätt.
</div>


<br><br>


<h4>da + [r] + preposition</h4>

<p>Några fler exempel på pronominaladverb är <b><i>dafür, damit, danach, darüber</i></b>.
    Slutdelen av ordet är samma som den preposition de hör ihop med. Om de börjar på
    vokal skjuts ett <b><i>-r-</i></b> in mellan första delen av ordet <b><i>da-</i></b>
    och slutledet.


    <div class="ruta">


        <p><i>Jag är <b>för</b> att bygga den nya vägen.</i></p>
        <p><i>Ich bin <b>dafür</b>, den neuen Weg zu bauen.</i></p>
        <br>
        <p><i>Vad gör du med stenen? Jag gör väl inget <b>med den</b>.</i></p>
        <p><i>Was machst du mit dem Stein? Ich mache doch nichts <b>damit</b></i></p>
        <br>
        <p><i>Vi längtar <b>efter det</b>.</i></p>
        <p><i>Wir sehnen uns <b>danach</b>.</i></p>
        <br>
        <p><i>Är du inte irriterad <b>över</b> de nya reglerna? Jo, jag är verkligen irriterad <b>över dem</b>.</i></p>
        <p><i>Ärgerst du dich nicht <b>über</b> die neuen Regeln? Doch, ich ärgere mich wirklich <b>darüber</b>.</i></p>
        <br>


    </div>

<br>
<div class="quasi-p mindre ej-lila">
För att veta vilka prepositioner som skall användas i abstrakta verbuttryck, se
    <router-link

     :to="'/grammatikboken/prepositioner-speciella-verbuttryck'">
        Prepositioner i speciella verbuttryck
    </router-link>
</div>

<br><br><br>




</div>


</div>



</template>

<script>

import BakatpilStor from '../grafik/bakatpilStor.vue'

export default {
  name: 'Grammatik',
  components: {
    BakatpilStor,
},

  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "pronominaladverb adverb pronominaladverbial"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
